import type { EntityState } from '@reduxjs/toolkit';

export type ChatRole = 'GAME_USER' | 'LIVE_SUPPORT' | 'SUPPORT';
export type ChatTagMessage = 'GAME_USER' | 'SUPPORT' | 'LIVE_SUPPORT';
export type ChatSubscriptionState = 'UNSUBSCRIBED' | 'SUBSCRIBED' | 'FRESH_CHAT_SUBSCRIBED';

export enum SendType {
  Table = 'TABLE',
  Notification = 'NOTIFICATION',
}

export enum ChatBlockType {
  BetRequired = 'BET_REQUIRED',
  LowBalance = 'LOW_BALANCE',
}

export interface UserType {
  url: string;
  userId: string;
  tableId: string;
  role: ChatRole;
  tableMinBet: number;
  xForwardedForIP: string;
  rank: number;
  blocked: boolean;
  active: boolean;
  casinoId: string;
  screenName: string;
  userTypeCode: string; // todo: add stricter type
  priveLoungePlayer: boolean;
  chatAllowed: boolean;
  betChatAllowed: boolean;
  supportChatAllowed: boolean;
  webSocketSessionId: string;
  unMaskedScreenName: string;
  priveLoungeHost: boolean;
  freeGamesCount: number;
  lang: string; // todo: add stricter type
  tableName: string;
  casinoName: string;
  operatorGameTableId: string;
  ppPlayerId: string;
  chatBlockType: ChatBlockType;
  casinoPPId: string;
  btplayer: boolean;
  hostName: string;
}

export interface Message {
  messageId: string;
  role: ChatRole;
  tagMessage: ChatTagMessage;
  content: string;
  userId?: string;
  timestamp: number;
  user?: UserType;
  userScreenName?: string;
  action?: string; // todo: add stricter type
  autoReply?: false;
  casinoId?: string;
  showHide?: boolean;
  showMessage?: boolean; // duplicate of showHide
  status?: string;
  tableId?: string;
  tableName?: string;
  sendType?: SendType;
  requireTranslation?: boolean;
  errorCode?: number;
  isliveSupportChat?: boolean; // casing is intentional, expected by backend
  betChatAllowed?: boolean;
  chatAllowed?: boolean;
}

export interface ChatState {
  gameChatMessages: EntityState<Message, Message['messageId']>;
  liveSupportChatMessages: EntityState<Message, Message['messageId']>;
  miniChatMessages: Message[];
  lastChatMessage: Message | null;
  isLiveSupportChatRead: boolean;
  isBetChatAllowed: boolean;
  chatBlockType: ChatBlockType;
  isGameChatBlocked: boolean;
  isLiveSupportChatBlocked: boolean;
  chatSubscriptionState: ChatSubscriptionState;
  isGameChatHistoryFetched: boolean;
}
